<div class="main-div plan-instructions ml-5">
  <div>
    <p>Faça um PIX no valor de <strong>R$ {{ selectedData.price }}</strong> utilizando o QRCode abaixo. O sistema reconhecerá automaticamente o pagamento em um periodo entre <strong>30 à 60 segundos</strong>. Bons estudos!
    </p>
    <div *ngIf="loading; else qrCode" class="d-flex justify-content-center">
      <div class="spinner-border text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <ng-template #qrCode>
      <img src="{{ qrCodeLink }}" width="226px" height="224px">
    </ng-template>
  </div>
  <!-- <div class="plan-instructions-footer">
    <input type="file" accept=".pdf" (change)="fileChangeEvent($event)" />
    <button class="btn btn-primary mt-4 mb-3" type="button" (click)="upload()">UPLOAD do comprovante</button>
  </div> -->
</div>
